export function calculateNumericScoreValue (answer) {
  switch (answer) {
    case 'No Information':
      return 0
    case 'No Concern':
      return 0
    case 'Possible Concern':
      return 1
    case 'Clear Concern':
      return 2
  }
}

export function translateIndicators (question) {
  switch (question) {
    case 'one_a_running':
      return '1 a. Running'
    case 'one_b_housing':
      return '1 b. Housing'
    case 'one_c_homeless':
      return '1 c. Homeless'
    case 'one_d_services':
      return '1 d. Services'
    case 'one_e_supervision':
      return '1 e. Supervision'
    case 'one_f_school':
      return '1 f. School'
    case 'one_g_cps':
      return '1 g. CPS'
    case 'two_a_secabuse':
      return '2 a. Sexual Abuse'
    case 'two_b_physicalabuse':
      return '2 b. Physical Abuse'
    case 'two_c_emotionalabuse':
      return '2 c. Emotional Abuse'
    case 'two_d_violence':
      return '2 d. Violence'
    case 'three_a_appearance':
      return '3 a. Appearance'
    case 'three_b_phystrauma':
      return '3 b. Physical Trauma'
    case 'three_c_tattoo':
      return '3 c. Tattoos'
    case 'three_d_pregsti':
      return '3 d. PregSTI'
    case 'three_e_sleep':
      return '3 e. Sleep'
    case 'three_f_nutrition':
      return '3 f. Nutrition'
    case 'three_g_sud':
      return '3 g. SUD'
    case 'three_h_increasesud':
      return '3 h. Increase SUD'
    case 'four_a_risksex':
      return '4 a. Risk Sex'
    case 'four_b_location':
      return '4 b. Location'
    case 'four_c_language':
      return '4 c. Language'
    case 'four_d_association':
      return '4 d. Association'
    case 'four_e_bullied':
      return '4 e. Bullied'
    case 'four_f_jj':
      return '4 f. JJ'
    case 'four_g_gang':
      return '4 g. Gangs'
    case 'five_a_unhealthyrel':
      return '5 a. Unhealthy Relationships'
    case 'five_b_onlinerel':
      return '5 b. Online Relationship'
    case 'five_c_photos':
      return '5 c. Photos'
    case 'five_d_money':
      return '5 d. Money'
    case 'five_e_manyphones':
      return '5 e. Many Phones'
    case 'five_f_travel':
      return '5 f. Travel'
    case 'six_a_hypervigilant':
      return '6 a. Hypervigilant'
    case 'six_b_cues':
      return '6 b. Cues'
    case 'six_c_risktaking':
      return '6 c. Risktaking'
    case 'six_d_celldistress':
      return '6 d. Cell Distress'
    case 'seven_a_abusive':
      return '7 a. Abusive'
    case 'seven_b_isolation':
      return '7 b. Isolation'
    case 'seven_c_pregnant':
      return '7 c. Pregnant'
    case 'seven_d_coercion':
      return '7 d. Safe Sleep'
    case 'seven_e_threats':
      return '7 e. Threats'
    case 'seven_f_vague':
      return '7 f. Vague'
    case 'eight_a_exploited':
      return '8 a. Exploited'
    case 'eight_b_filmed':
      return '8 b. Filmed'
    case 'eight_c_history':
      return '8 c. History'
    case 'eight_d_quota':
      return '8 d. Quota'
    default:
      return question
  }
}

export function calculateQuestionScore (total, question) {
  let indicatorScore = 'No Concern'

  if (question === 'One') {
    if (total >= 4 && total < 6) {
      indicatorScore = 'Possible Concern'
    } else if (total >= 6) {
      indicatorScore = 'Clear Concern'
    }
  } else if (question === 'Two') {
    if (total === 2) {
      indicatorScore = 'Possible Concern'
    } else if (total >= 3) {
      indicatorScore = 'Clear Concern'
    }
  } else if (question === 'Three') {
    if (total >= 2 && total < 4) {
      indicatorScore = 'Possible Concern'
    } else if (total >= 4) {
      indicatorScore = 'Clear Concern'
    }
  } else if (question === 'Four') {
    if (total === 1) {
      indicatorScore = 'Possible Concern'
    } else if (total >= 2) {
      indicatorScore = 'Clear Concern'
    }
  } else if (question === 'Five') {
    if (total >= 1 && total < 3) {
      indicatorScore = 'Possible Concern'
    } else if (total >= 3) {
      indicatorScore = 'Clear Concern'
    }
  } else if (question === 'Six') {
    if (total >= 1 && total < 3) {
      indicatorScore = 'Possible Concern'
    } else if (total >= 3) {
      indicatorScore = 'Clear Concern'
    }
  } else if (question === 'Seven') {
    if (total === 1) {
      indicatorScore = 'Possible Concern'
    } else if (total >= 2) {
      indicatorScore = 'Clear Concern'
    }
  } else if (question === 'Eight') {
    if (total === 1) {
      indicatorScore = 'Possible Concern'
    } else if (total >= 2) {
      indicatorScore = 'Clear Concern'
    }
  }

  return indicatorScore
}



// WEBPACK FOOTER //
// ./src/helpers/cseit.js